import React, { useState, useEffect } from 'react';
import './../styles/GetAQuote.css';
import { quoteForm } from '../services/Service';
import { FiGlobe, FiBriefcase, FiChevronDown, FiUser, FiMail, FiPhone, FiMessageSquare, FiUpload } from 'react-icons/fi';
import { BiRupee } from "react-icons/bi";

const GetAQuote = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    company: '',
    website: '',
    service: '',
    file: null,
    file_name: '',
    overview: '',
    budget: '',
    timeline: '',
    message: ''
  });
  // const [focusedSelect, setFocusedSelect] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: ''
      }));
    }
  };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setFormData({
  //       ...formData,
  //       file: file,
  //       file_name: file.name
  //     });
  //   }
  // };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        setErrors(prev => ({ ...prev, file: 'File size must be less than 5MB.' }));
      } else if (!['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(file.type)) {
        setErrors(prev => ({ ...prev, file: 'Only PDF or DOC files are allowed.' }));
      } else {
        setFormData(prev => ({
          ...prev,
          file,
          file_name: file.name
        }));
        setErrors(prev => {
          const { file, ...rest } = prev;
          return rest;
        });
      }
    }
  };

  // const handleBlur = (field, message) => {
  //   if (!formData[field].trim()) {
  //     setErrors((prev) => ({ ...prev, [field]: message }));
  //   } else {
  //     setErrors((prev) => {
  //       const { [field]: removed, ...rest } = prev;
  //       return rest;
  //     });
  //   }
  // };


  const validateForm = () => {
    const newErrors = {};
    if (!formData.fullName.trim()) {
      newErrors.fullName = 'Full name is required.';
    } else if (formData.fullName.length > 255) {
      newErrors.fullName = 'Your full name cannot be longer than 255 characters.';
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (formData.email.trim().length > 255) {
      newErrors.email = 'Your email cannot be longer than 255 characters.';
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email.trim())) {
      newErrors.email = 'Please enter a valid email.';
    }
    if (!formData.phone) {
      newErrors.phone = 'Phone number is required.';
    } else if (!/^\d{9,12}$/.test(formData.phone)) {
      newErrors.phone = 'Enter a valid phone number. It must be between 9 and 12 digits.';
    }
    if (!formData.service.trim()) newErrors.service = 'Please select a service.';
    // if (!formData.file) {
    //   newErrors.file = 'Please upload a file.';
    // } else 
    if (formData.file) {
    if (formData.file.size > 5 * 1024 * 1024) {
      newErrors.file = 'File size must be less than 5MB.';
    } else if (!['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(formData.file.type)) {
      newErrors.file = 'Only PDF, DOC, or DOCX files are allowed.';
    }}
    if (!formData.overview.trim()) {
      newErrors.overview = 'Project overview is required.';
    } else if (formData.overview.length > 255) {
      newErrors.overview = 'Your overview cannot be longer than 255 characters.';
    }
    if (!formData.budget) newErrors.budget = 'Estimated Budget is required.';
    if (!formData.timeline.trim()) newErrors.timeline = 'Project Start Timeline is required.';
    if (formData.message.length > 255) newErrors.message = 'Your Message cannot be longer than 255 characters.';
    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    setErrors({});
    if (Object.keys(newErrors).length === 0) {
      try {
        // Here you would typically send the form data to your backend
        const result = await quoteForm(formData);
        if (result && result.data.message === 'Quote successfully created.') {
          // setIsSubmitting(true);
          setIsSubmitted(true);
          window.scrollTo(0, 0);
          // Simulate API call
          setTimeout(() => {
            // setIsSubmitting(false);
            setIsSubmitted(true);
          }, 2000);
          setFormData({
            fullName: '',
            email: '',
            phone: '',
            company: '',
            website: '',
            service: '',
            file: null,
            file_name: '',
            overview: '',
            budget: '',
            timeline: '',
            message: ''
          });
        } else {
          setErrors(newErrors);
        }
      } catch (error) {
        setErrors({ form: 'An unexpected error occurred. Please try again later.' });
        setIsSubmitted(false);
      }
    } else {
      setErrors(newErrors);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isSubmitted) {
    return (
      <div className="quote-container">
        <div className="success-message">
          <h3>Thank You!</h3>
          <p>We've received your quote request. Our team will review your project details and get back to you within 24 hours.</p>
          <p>In the meantime, feel free to explore our portfolio or contact us directly if you have urgent inquiries.</p>
        </div>
        <div className="center-btn">
          <button
            className="back-to-form-btn"
            onClick={() => {
              setIsSubmitted(false);
              // setSubmittedData(null);
            }}
          >
            Submit Another Quote
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="quote-container">
      <h2>Start With a Custom Consultation</h2>
      <p className="subtitle">
        Know Your Investment Upfront - Get a Detailed Quote.
      </p>
      <div className="quote-form-content">
        <form className="quote-form" onSubmit={handleSubmit} noValidate>
          <div className="form-row">
            <div className={`form-group required ${errors.fullName ? 'has-error' : ''}`}>
              <label htmlFor="fullNamed">Full Name</label>
              <div className="input-with-icon">
                <FiUser className="input-icon" />
                <input
                  type="text"
                  id="fullName"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Enter Full Name"
                  className={errors.fullName ? 'error' : ''}
                  autoComplete="off"
                  // required
                  onBlur={() => {
                    if (!formData.fullName.trim()) {
                      setErrors((prev) => ({ ...prev, fullName: 'Full name is required.' }));
                    } else {
                      setErrors((prev) => {
                        const { fullName, ...rest } = prev;
                        return rest;
                      });
                    }
                  }}
                />
              </div>
              {errors.fullName && <span className="error-message">{errors.fullName}</span>}
            </div>
            <div className={`form-group required ${errors.email ? 'has-error' : ''}`}>
              <label htmlFor="email">Email</label>
              <div className="input-with-icon">
                <FiMail className="input-icon" />
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter Email"
                  value={formData.email}
                  onChange={handleChange}
                  className={errors.email ? 'error' : ''}
                  autoComplete="off"
                  // required
                  // onBlur={() => handleBlur('fullName', 'Full name is required.')}
                  onBlur={() => {
                    if (!formData.email.trim()) {
                      setErrors((prev) => ({ ...prev, email: 'Email is required.' }));
                    } else {
                      setErrors((prev) => {
                        const { email, ...rest } = prev;
                        return rest;
                      });
                    }
                  }}
                />
              </div>
              {errors.email && <span className="error-message">{errors.email}</span>}
            </div>
          </div>
          <div className="form-row">
            <div className={`form-group required ${errors.phone ? 'has-error' : ''}`}>
              <label htmlFor="phone">Phone Number</label>
              <div className="input-with-icon">
                <FiPhone className="input-icon" />
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="Enter Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  className={errors.phone ? 'error' : ''}
                  autoComplete="off"
                  // required
                  onBlur={() => {
                    if (!formData.phone.trim()) {
                      setErrors((prev) => ({ ...prev, phone: 'Phone number is required.' }));
                    } else {
                      setErrors((prev) => {
                        const { phone, ...rest } = prev;
                        return rest;
                      });
                    }
                  }}
                />
              </div>
              {errors.phone && <span className="error-message">{errors.phone}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="company">Company (Optional)</label>
              <div className="input-with-icon">
                <FiBriefcase className="input-icon" />
                <input
                  type="text"
                  id="company"
                  name="company"
                  placeholder="Enter Company Name"
                  value={formData.company}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="website">Website (If any)</label>
            <div className="input-with-icon">
              <FiGlobe className="input-icon" />
              <input
                type="text"
                id="website"
                name="website"
                placeholder="Enter Website"
                value={formData.website}
                onChange={handleChange}
                autoComplete="off"
              />
            </div>
          </div>
          <div className="form-row">
            <div className={`form-group required ${errors.service ? 'has-error' : ''}`}>
              <label htmlFor="service">Service Type</label>
              <div className="custom-select">
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  // onFocus={() => setFocusedSelect('service')}
                  // onBlur={() => setFocusedSelect(null)}
                  onBlur={() => {
                    if (!formData.service) {
                      setErrors((prev) => ({ ...prev, service: 'Please select a service.' }));
                    } else {
                      setErrors((prev) => {
                        const { service, ...rest } = prev;
                        return rest;
                      });
                    }
                  }}
                  // required
                  className={errors.service ? 'error' : ''}
                >
                  <option value="">Select a service</option>
                  <option value="web">Website Development</option>
                  <option value="mobile">Mobile App Development</option>
                  <option value="ecommerce">E-commerce Solutions</option>
                  <option value="seo">SEO & Digital Marketing</option>
                  <option value="custom">Custom Software</option>
                  <option value="other">Other</option>
                </select>
                <FiChevronDown className={`select-arrow`} />
              </div>
              {errors.service && <span className="error-message">{errors.service}</span>}
            </div>
            <div className="form-row">
              {/* <div className={`form-group required ${errors.file ? 'has-error' : ''}`}> */}
              <div className="form-group">
                <label>Upload File</label>
                <div className={`file-upload ${errors.file ? 'error' : ''}`}>
                  <label htmlFor="file" className="file-upload-label">
                    <FiUpload className="upload-icon" />
                    <span>
                      {formData.file_name || ' Choose file (PDF, DOC)'}
                    </span>
                    <input
                      type="file"
                      id="file"
                      name="file"
                      onChange={handleFileChange}
                      accept=".pdf,.doc,.docx"
                      className={errors.file ? 'error' : ''}
                      onBlur={() => {
                        if (!formData.file) {
                          setErrors((prev) => ({ ...prev, file: 'Please upload file.' }));
                        } else {
                          setErrors((prev) => {
                            const { file, ...rest } = prev;
                            return rest;
                          });
                        }
                      }}
                    // required
                    />
                  </label>
                </div>
                <div className="file-hint-container">
                  <p className="file-hint">Max file size: 5MB</p>
                  {errors.file && <span className="error-message">{errors.file}</span>}
                </div>

              </div>
            </div>
          </div>
          {/* <div className={`form-group required ${errors.service ? 'has-error' : ''}`}>
            <label htmlFor="service">Service Type</label>
            <div className="custom-select">
              <select
                id="service"
                name="service"
                value={formData.service}
                onChange={handleChange}
                // onFocus={() => setFocusedSelect('service')}
                // onBlur={() => setFocusedSelect(null)}
                onBlur={() => {
                  if (!formData.service) {
                    setErrors((prev) => ({ ...prev, service: 'Please select a service.' }));
                  } else {
                    setErrors((prev) => {
                      const { service, ...rest } = prev;
                      return rest;
                    });
                  }
                }}
                // required
                className={errors.service ? 'error' : ''}
              >
                <option value="">Select a service</option>
                <option value="web">Website Development</option>
                <option value="mobile">Mobile App Development</option>
                <option value="ecommerce">E-commerce Solutions</option>
                <option value="seo">SEO & Digital Marketing</option>
                <option value="custom">Custom Software</option>
                <option value="other">Other</option>
              </select>
              <FiChevronDown className={`select-arrow${focusedSelect === 'service' ? ' open' : ''}`} />
            </div>
            {errors.service && <span className="error-message">{errors.service}</span>}
          </div> */}
          <div className={`form-group required ${errors.overview ? 'has-error' : ''}`}>
            <label htmlFor="overview">Project Overview</label>
            <div className="input-with-icon">
              <FiMessageSquare className="input-icon" />
              <textarea
                id="overview"
                name="overview"
                placeholder="Tell us about your project goals, target audience, and any specific requirements..."
                value={formData.overview}
                onChange={handleChange}
                className={errors.overview ? 'error' : ''}
                onBlur={() => {
                  if (!formData.overview) {
                    setErrors((prev) => ({ ...prev, overview: 'Project overview is required.' }));
                  } else {
                    setErrors((prev) => {
                      const { overview, ...rest } = prev;
                      return rest;
                    });
                  }
                }}
              // required
              />
            </div>
            {errors.overview && <span className="error-message">{errors.overview}</span>}
          </div>
          <div className="form-row">
            <div className={`form-group required ${errors.budget ? 'has-error' : ''}`}>
              <label htmlFor="budget">Estimated Budget</label>
              <div className="input-with-icon">
                <BiRupee className="input-icon" />
                <input
                  type="text"
                  id="budget"
                  name="budget"
                  placeholder="Enter Budget"
                  value={formData.budget}
                  onChange={handleChange}
                  className={errors.budget ? 'error' : ''}
                  autoComplete="off"
                  // required
                  onBlur={() => {
                    if (!formData.budget) {
                      setErrors((prev) => ({ ...prev, budget: 'Estimated Budget is required.' }));
                    } else {
                      setErrors((prev) => {
                        const { budget, ...rest } = prev;
                        return rest;
                      });
                    }
                  }}
                />
              </div>
              {errors.budget && <span className="error-message">{errors.budget}</span>}
            </div>
            <div className={`form-group required ${errors.timeline ? 'has-error' : ''}`}>
              <label htmlFor="timeline">Project Start Timeline</label>
              <div className="custom-select">
                <select
                  id="timeline"
                  name="timeline"
                  value={formData.timeline}
                  onChange={handleChange}
                  className={errors.timeline ? 'error' : ''}
                  onBlur={() => {
                    if (!formData.timeline) {
                      setErrors((prev) => ({ ...prev, timeline: 'Project Start Timeline is required.' }));
                    } else {
                      setErrors((prev) => {
                        const { timeline, ...rest } = prev;
                        return rest;
                      });
                    }
                  }}
                // required
                >
                  <option value="">Select timeline</option>
                  <option value="immediately">Immediately</option>
                  <option value="1-2 weeks">1-2 Weeks</option>
                  <option value="1 month">In a Month</option>
                  <option value="later">Later</option>
                </select>
                <FiChevronDown className="select-arrow" />
              </div>
              {errors.timeline && <span className="error-message">{errors.timeline}</span>}
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="message">Additional Notes</label>
            <div className="input-with-icon">
              <FiMessageSquare className="input-icon" />
              <textarea
                id="message"
                name="message"
                placeholder="Any other details we should know about?"
                value={formData.message}
                onChange={handleChange}
                className={errors.message ? 'error' : ''}
              />
            </div>
            {errors.message && <span className="error-message">{errors.message}</span>}
          </div>
          <button type="submit" className="submit-btn" style={{ marginTop: '1rem' }}>Submit</button>
        </form>
      </div>
    </div>
  );
};

export default GetAQuote;